import * as CommonTypes from '../actionTypes/commonTypes'
import * as TaskTypes from '../actionTypes/taskTypes'
import * as LinkTypes from '../actionTypes/linkTypes'
import * as MustReadTypes from '../actionTypes/mustReadTypes'
import * as MoveItemTypes from '../actionTypes/moveItemTypes'
import { resolveSceneBackground } from '../backgroundScenes'
import { Notification } from '../../../models/Notification'
import { StoryScene } from '../../../models/Story'

const allowedEventsTypes = [
    CommonTypes.UserAddItem,
    CommonTypes.UserAddComment,
    TaskTypes.UserAddTask,
    TaskTypes.UserDoneTask,
    TaskTypes.UserDoneDueDateTask,
    LinkTypes.UserLinkedItem,
    MustReadTypes.UserAskedToReadItem,
    MustReadTypes.UserReadItem,
    MoveItemTypes.UserMoveItemLane
]

const filterChatNotifications = (notif: Notification): boolean => !notif.isChatNotification
const filterAllowedNotifications = (notif: Notification): boolean => allowedEventsTypes.includes(notif.systemActionTypeUid)

export const applyFilters = (notifications: Notification[]) => {
    return notifications
        .filter(filterChatNotifications)
        .filter(filterAllowedNotifications)
}

export interface NotificationsByUser { [key: string]: Notification[] }

export const getNotificationsByUser = (notifications: Notification[] = []): NotificationsByUser => notifications.reduce((accum: NotificationsByUser, notif: Notification) => {
    const {userThatMadeTheAction} = notif
    if(!userThatMadeTheAction) return accum

    const {auth0_id} = userThatMadeTheAction

    if(auth0_id in accum) return {...accum, [auth0_id]: [...accum[auth0_id], notif]}
    return {...accum, [auth0_id]: [notif]}
}, {})

export const applyNotificationsToScenes = (notifs: Notification[] = []): StoryScene[] => {
    return notifs
        .map(notif => {
            const [backgroundUrl, sceneStyles] = resolveSceneBackground(notif)
            return {
            dataType: notif.dataType,
            groupType: notif.groupType,
            backgroundUrl,
            sceneStyles,
            seen: false,
            timestamp: new Date(notif.created).getTime(),
            systemActionTypeUid: notif.systemActionTypeUid,
            docId: notif.docId,
            collection: notif.collection,
            id: notif.id,
            messageTemplateParams: notif.messageTemplateParams,
            message: notif.topic,
            whyDoISeeThisItem: notif.whyDoISeeThisItem
        }})
        .sort((a, b) => a.timestamp - b.timestamp)
}
